var _ = require('lodash');

require('./bootstrap');
import Vue from 'vue'
require('./filters.js');
import App from './App.vue'
import InfiniteLoading from 'vue-infinite-loading';
import router from './router'
import config from './config';
import './permission'; // permission control
import store from './store';
import './utilis/request';
import './utilis/auth';
import vuetify from './plugins/vuetify';
import './registerServiceWorker'
import prototypes from './prototypes';
import VueApexCharts from 'vue-apexcharts'
import VueKonva from 'vue-konva';
Vue.use(VueKonva);
import {i18n} from "./plugins/i18n";
import mixins from './mixins';
import 'intro.js/introjs.css';
import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs-preset-webpage/dist/grapesjs-preset-webpage.min.css';
import VueDragTree from 'vue-drag-tree'
import 'vue-drag-tree/dist/vue-drag-tree.min.css'
import Product from './plugins/product';
import tinymce from 'vue-tinymce-editor'
Vue.mixin(mixins);
Vue.use(VueDragTree);
Vue.component('apexchart', VueApexCharts)
Vue.use(prototypes);
Vue.use(InfiniteLoading, { /* options */ });
Vue.component('media-picker', require('./components/media-picker').default);
Vue.component('my-page-builder', require('./components/my-page-builder').default);
Vue.component('color-chip', require('./components/color-chip').default);
Vue.component('my-form', require('./components/my_form').default);
Vue.component('primary-button', require('./components/primary-button').default);
Vue.component('danger-button', require('./components/danger-button').default);
Vue.component('secondary-button', require('./components/secondary-button').default);
require('./register-components.js');
Vue.component('tinymce', tinymce)
Vue.config.productionTip = false
Vue.prototype.$eventBus = new Vue();
Vue.prototype.$product = new Vue(Product);
Vue.filter('currency', function (value) {
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return parseFloat(formatter.format(value)).toFixed(2);
});
Vue.directive('chunk', {
  inserted: function (el, data) {
    var leng = (data.value)? data.value : 15;
    if($(el).text().length > leng){
      var tmp = document.createElement('a');
      tmp.classList.add('my-link');
      tmp.innerText = $(el).text().substring(0,leng)+'...';
      tmp.setAttribute('data-text', $(el).text());
      tmp.addEventListener('click', function (el) {
        $(tmp).replaceWith($(tmp).attr('data-text'));
      })
      $(el).replaceWith(tmp);
    }
  }
})
Vue.filter('truncate', function (text, stop, clamp) {
  if(!text) return '';
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})
Vue.mixin({
  data(){
    return{
      errors:[],
    }
  },
  watch:{
  },
  methods:{
    getSrc(src){
      return this.$root.getSrc(src);
    },
    getStorSrc(src){
      return config.stor+''+src;
    },
    resetErrors(){
      setTimeout(() => {
        this.errors = [];
      }, 3000)
    },
    startLoading(){
      this.$store.commit('app/setLoading', true);
    },
    stopLoading(){
      setTimeout(() => {
        this.$store.commit('app/setLoading', false);
      }, 1000);
    },
    getStatusColor(status){
      if(status == 'new') return 'primary'
      if(status == 'completed') return 'green';
      if(status == 'canceled') return 'red';
    }
  }
})

new Vue({
  store,
  router,
  vuetify,
  i18n,
  data(){
    return{
      base_url: null
    }
  },
  mounted(){
    this.base_url = config.config.base_url;
  },
  methods:{
    isMobile(){
      if(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) return true
      else return false;
    },
    getSrc(src){
      if(src && src.startsWith('data:image/')) return src;
      return config.storage+''+src;
    }
  },
  render: h => h(App)
}).$mount('#app')

